import { render, staticRenderFns } from "./tabFour.vue?vue&type=template&id=24584a16"
import script from "./tabFour.vue?vue&type=script&lang=js"
export * from "./tabFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports